import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureHouseholdReviewModule } from '../lib/shared-feature-household-review.module'
import { HouseholdReviewExampleComponent } from './household-review-docs/examples/household-review-example.component'
import { HouseholdReviewDocsComponent } from './household-review-docs/household-review-docs.component'

@NgModule({
  declarations: [
    HouseholdReviewDocsComponent,
    HouseholdReviewExampleComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureHouseholdReviewModule
  ],
  exports: [HouseholdReviewDocsComponent],
  providers: []
})
export class SharedFeatureHouseholdReviewDocsModule {}
